import Card from './Card.vue';
import { NAME } from './constants';

export const ZakazkyRef = {
	name: NAME,
	components: {
		Card,
	},
};
